<!DOCTYPE html>
<html lang="en">
<head>
    <title>Admin Login</title>
</head>
<body>
	<div class="page" style="background-image: url(../../../assets/images/login-bg.jpg);background-size: cover;background-repeat: no-repeat;">
		<div class="container pt-70">
            <div class="modal inmodal" id="forgetpassModal" tabindex="-1" role="dialog" aria-hidden="true">
                <form #forgetPasswordForm="ngForm" (ngSubmit)="forgetPassword()">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content animated flipInY">
                            <div class="modal-header">
                                <h4 class="modal-title">Forget Password</h4>
                                <button type="button" class="close" data-dismiss="modal" (click)="closeForm()"><span
                                        aria-hidden="true">&times;</span>
                                    <span class="sr-only">Close</span></button>
                            </div>
                            <div class="modal-body modal_box">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label class="form-label ">Registered email id or mobile no.<span class="text-danger">
                                                    *</span></label>
                                            <input class="form-control" type="text" name="emailid"
                                                id="emailid"
                                                placeholder="Enter registered email id or mobile no"
                                                #emailid="ngModel" ngModel required />
                                            <span *ngIf="forgetPasswordForm.submitted && emailid.invalid">
                                                <p *ngIf="emailid.errors.required" class="error_message"
                                                    style="color: red">
                                                    Registered email id or mobile no. is required
                                                </p>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <button class="btn btn-primary" type="submit"
                                        style="margin: 5px;">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
			<div class="row justify-content-center" style="margin-top: -5%;">
				<div class="col-lg-6 col-md-12 col-12">	
                    <div class="login-logo">
                        <img src="../../../assets/images/vnsgu.jpg" alt="Logo"/>
                    </div>				
					<div class="login-box">
						<div class="icon-box">
							<img src="assets/images/cap.png" class="img-fluid i_img">
						</div>
						<h4>Sign In</h4>
						<form #loginForm="ngForm" (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label>User name<span class="text-danger">*</span></label>
                                <input type="text" #userName="ngModel" ngModel name="userName" class="form-control" placeholder="Enter user name" required>
                                <span *ngIf="loginForm.submitted && userName.invalid">
                                    <p *ngIf="userName.errors.required" class="error_message" style="color: red;">
                                        User name is required
                                    </p>
                                </span>
                            </div>
                            <div class="form-group">
                                <label>Password<span class="text-danger">*</span></label>
                                <input type="password" #password="ngModel" ngModel name="password" autocomplete="off" class="form-control" placeholder="Enter password" required>
                                <span *ngIf="loginForm.submitted && password.invalid">
                                    <p *ngIf="password.errors.required" class="error_message" style="color: red;">
                                        Password is required
                                    </p>
                                </span>
                            </div>
                            <div class="text btn" style="float: right;"><a class="r-link" style="font-size: 15px;"
                                (click)="openpopup()">Forgot
                                Password?</a></div>
                             <br><button type="submit" class="btn btn-primary btn-block mt-3">Sign In</button>
                        </form>
					</div>
				</div>
			</div>
		</div>
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</body>